// eslint-disable-next-line no-shadow
export enum DraggableItemType {
  QUESTION_OPTION = 'questionOption'
}
